import { render, staticRenderFns } from "./faltantes_compromiso.vue?vue&type=template&id=67436c80"
import script from "./faltantes_compromiso.vue?vue&type=script&lang=js"
export * from "./faltantes_compromiso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports